import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const COMPETENCE="competencia"
const DIMENSION= `${COMPETENCE}/dimension`
const DIMENSION_TYPE= `${DIMENSION}/type`
const CATEGORY= `${COMPETENCE}/category`
const PREGUNTA= (id)=>`${COMPETENCE}/${id}/pregunta`
const QUESTION_TYPE= `${COMPETENCE}/question/type`
const QUESTION= `${COMPETENCE}/question`

//Competence

export const competenceGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(COMPETENCE,{params,signal:controller.signal})
    return {call,controller}
}

export const competenceIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${COMPETENCE}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const competencePost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(COMPETENCE,data,{params,signal:controller.signal})
    return {call,controller}
}

export const CompetencePut= (id,data) => {
    const controller= loadAbort()
    const call= axios.put(`${COMPETENCE}/${id}`,data,{signal:controller.signal})
    return {call,controller}
}
export const CompetenceDelete= (id) => {
    const controller= loadAbort()
    const call= axios.delete(`${COMPETENCE}/${id}`,{signal:controller.signal})
    return {call,controller}
}
//Pregunta
export const preguntaGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(PREGUNTA(id),{params,signal:controller.signal})
    return {call,controller}
}
export const preguntaIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${QUESTION}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const questionTypeGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(QUESTION_TYPE,{params,signal:controller.signal})
    return {call,controller}
}

export const QuestionPost = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.post(PREGUNTA(id),data,{params,signal:controller.signal})
    return {call,controller}
}
export const QuestionPut= (id,data) => {
    const controller= loadAbort()
    const call= axios.put(`${QUESTION}/${id}`,data,{signal:controller.signal})
    return {call,controller}
}

export const QuestionDelete= (id) => {
    const controller= loadAbort()
    const call= axios.delete(`${QUESTION}/${id}`,{signal:controller.signal})
    return {call,controller}
}

//Dimension
export const dimensionGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(DIMENSION,{params,signal:controller.signal})
    return {call,controller}
}
export const dimensionIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${DIMENSION}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const dimensionTypeGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(DIMENSION_TYPE,{params,signal:controller.signal})
    return {call,controller}
}
export const dimensionPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(DIMENSION,data,{params,signal:controller.signal})
    return {call,controller}
}
export const dimensionPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${DIMENSION}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}
export const dimensionDelete = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.delete(`${DIMENSION}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}

//Category
export const CategoryGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(CATEGORY,{params,signal:controller.signal})
    return {call,controller}
}
export const CategoryIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${CATEGORY}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const CategoryPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(CATEGORY,data,{params,signal:controller.signal})
    return {call,controller}
}
export const CategoryPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${CATEGORY}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}

export const CategoryDelete = (id) => {
    const controller= loadAbort()
    const call= axios.delete(`${CATEGORY}/${id}`,{signal:controller.signal})
    return {call,controller}
}


